export const replaceSrcSetWithCurrentSrc = (
  images: NodeListOf<HTMLImageElement>,
  outputNode: HTMLElement
) => {
  // currentSrc is empty in the outputNode, because it's all in memory and nothing is loaded
  // so we need to get the currentSrc from the original image

  const outputNodeImages = outputNode.querySelectorAll('img');

  const imagesWithSrcSet = Array.from(images).filter(image => image.srcset);

  const imagesWithCurrentSrc = imagesWithSrcSet.filter(
    image => image.currentSrc
  );

  const imagesWithoutCurrentSrc = imagesWithSrcSet.filter(
    image => !image.currentSrc
  );

  imagesWithCurrentSrc.forEach(image => {
    const imagesToMutate = Array.from(outputNodeImages).filter(
      img => img.srcset === image.srcset
    );

    imagesToMutate.forEach(img => {
      img.src = image.currentSrc;
      img.removeAttribute('srcset');
    });
  });

  // For images in the source that don't have a currentSrc
  // safe to assume they havent loaded, so are not needed
  // we dont want to delete the element due to styling etc.
  // so we just remove the src attribute
  // so we don't have to download the image

  imagesWithoutCurrentSrc.forEach(image => {
    const imagesToMutate = Array.from(outputNodeImages).filter(
      img => img.srcset === image.srcset
    );

    imagesToMutate.forEach(img => {
      img.removeAttribute('src');
    });
  });
};
